import { useLandingStore } from "src/modules/pe-landing-module/data/store";
import saveLocal from "./saveLocal";
import saveExtended from "./saveExtended";
import { ID } from "src/libs/interfaces/layouts";

export default function save( src: string ) {
    const isLocal: boolean  = useLandingStore.getState().isLocal
    const land_id: ID       = useLandingStore.getState().land_id
    const landing_id: ID    = useLandingStore.getState().landing_id
    if( isLocal) {
        saveLocal(src)
    } 
    else {
        saveExtended(src, landing_id, land_id)
    }
}